// api/error-handler.js
import { Notice } from 'view-ui-plus';

// 全局错误处理器
export const SetupErrorHandler = (Vue) => {
    // 处理Vue运行时错误
    Vue.config.errorHandler = (err, vm, info) => {
        console.error('Vue错误:', err, info);
        ShowErrorNotification({
            title: '应用程序错误',
            message: '发生了一个Vue运行时错误，请刷新页面或联系支持人员。',
            details: err.message
        });
    };
    // 处理未捕获的Promise拒绝
    window.addEventListener('unhandledrejection', (event) => {
        // console.error('未处理的Promise拒绝:', event.reason);
        event.preventDefault();
        ShowErrorNotification({
            title: '异步操作错误',
            message: '发生了一个异步操作错误，请刷新页面或联系支持人员。',
            details: event.reason.message
        });
    });
    // 处理未捕获的常规错误
    window.addEventListener('error', (event) => {
        console.error('未捕获的错误:', event.error);
        event.preventDefault();
        ShowErrorNotification({
            title: 'JavaScript错误',
            message: '发生了一个JavaScript错误，请刷新页面或联系支持人员。',
            details: event.error.message
        });
    });
};

// 显示错误通知
export const ShowErrorNotification = (errorInfo) => {
    Notice.error({
        title: errorInfo.title,
        desc: errorInfo.message,
        duration: 5,
        onClose: () => {
            // 可选的关闭回调
        }
    });
};
